document.addEventListener('DOMContentLoaded', () => {
  const benefits = document.querySelector('.elfine-benefits');
  if (!benefits) return;

  const items = benefits.querySelectorAll(':scope > div');
  if (items[1]) {
    const title = items[1].querySelector('strong');
    const subtitle = items[1].querySelector('small');
    if (title) title.textContent = '14 Days Exchange';
    if (subtitle) subtitle.textContent = 'Easy size & style exchanges';
  }

  if (!benefits.querySelector('[data-elfine-secure-checkout]')) {
    const item = document.createElement('div');
    item.setAttribute('data-elfine-secure-checkout', '');
    item.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="6" y="13" width="20" height="14" rx="2"></rect><path d="M10 13V9a6 6 0 0 1 12 0v4"></path><path d="m13 20 2 2 4-4"></path></svg><span><strong>Secure checkout</strong><small>Protected payment options</small></span>';
    benefits.appendChild(item);
  }
});
